import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";

import { mhpTreatmentApi } from "./mhpTreatmentApi";
import { LOAD_MHP_TREATMENT_REPORT, VIEWED_MHP_TREATMENT_REPORT } from "./actionTypes";

export const loadMHPTreatmentReportByViewTaskId = (ohCaseId: string, viewReportTaskId: string, questionnaireKey: string) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(dispatch, LOAD_MHP_TREATMENT_REPORT, mhpTreatmentApi.loadReportByViewTaskId(ohCaseId, viewReportTaskId));
        const questions = response.data.questions;
        dispatch(questionnaireLoaded({
            questions,
            questionnaireKey,
            eTag: response.eTag,
            isDefaultCustomerType: response.isDefaultCustomerType,
            customerType: response.customerType,
            reportChangesBlocked: response.reportChangesBlocked,
            releaseReportComments: response.releaseReportComments,
            approvalState: response.approvalState
        }));
        await loadAndTrack(dispatch, VIEWED_MHP_TREATMENT_REPORT, mhpTreatmentApi.viewReport(ohCaseId, viewReportTaskId));
    };
};
